import { render, staticRenderFns } from "./UserGuideTabs.vue?vue&type=template&id=413a6777&scoped=true"
import script from "./UserGuideTabs.vue?vue&type=script&lang=js"
export * from "./UserGuideTabs.vue?vue&type=script&lang=js"
import style0 from "./UserGuideTabs.vue?vue&type=style&index=0&id=413a6777&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413a6777",
  null
  
)

export default component.exports